import React from "react"
import { makeStyles, Box, Typography } from "@material-ui/core"
import { Avatar } from ".."
import { UserStatusChip } from "../Chips"
import TimeAgo from "../TimeAgo"
import { useAuth } from "../../services"

const useStyles = makeStyles((theme) => ({
  panel: {
    width: ({ layout }) => (layout === "landscape" ? "100%" : 322),
    backgroundColor: theme.palette.shaded.filter,
    borderRadius: "8px",
    textAlign: ({ layout }) => (layout === "portrait" ? "center" : "left"),
  },
  avatar: {
    width: 80,
    height: 80,
    fontSize: 24,
  },
  nameTitle: {
    color: theme.palette.avatar.circle.color,
    fontSize: 24,
    fontWeight: "500",
    lineHeight: "30px",
  },
  groups: {
    color: theme.palette.avatar.circle.color,
    fontSize: 14,
    lineHeight: "16px",
  },
  locations: {
    color: theme.palette.text.light,
    fontSize: 14,
    lineHeight: "16px",
  },
  lastSeen: {
    color: theme.palette.text.tinted,
    fontSize: 13,
    lineHeight: "16px",
    whiteSpace: "nowrap",
  },
}))

const UserPanel = ({
  layout = "portrait",
  user: { id, firstName, lastName, avatar, groups, locations, status, invite, activeAt },
  className = "",
  mr = 5,
  ...rest
}) => {
  const classes = useStyles({ layout })
  const { isCurrentUser } = useAuth()
  const isPortrait = layout === "portrait"
  const isLandscape = layout === "landscape"

  return (
    <Box mr={mr} className={`${classes.panel} ${className}`} {...rest}>
      <Box display="flex" flexDirection={isPortrait ? "column" : "row"} alignItems="center" py={3} px={3}>
        <Avatar {...{ firstName, lastName, avatar }} className={classes.avatar} />
        <Box mt={isPortrait ? 2 : 0} ml={isLandscape ? 2 : 0} flexGrow={1}>
          <Box
            mb={isPortrait ? 0.5 : 0}
            display="flex"
            flexGrow={1}
            justifyContent={isPortrait ? "center" : "flex-start"}
          >
            <Typography component="h1" className={classes.nameTitle}>
              {firstName} {lastName}
            </Typography>
          </Box>
          <Box className={classes.groups} mb={0.5}>
            {groups && groups.map((group) => group.name).join(", ")}
          </Box>
          <Box className={classes.locations}>
            {locations && locations.length > 0 && locations.map((location) => location.name).join(", ")}
          </Box>
        </Box>
        <Box
          mt={isPortrait ? 2 : 0}
          alignItems={isLandscape ? "flex-end" : "center"}
          justifyItems={isLandscape ? "flex-end" : "flex-start"}
          display="flex"
          flexDirection="column"
        >
          <Box mb={0.5}>
            <UserStatusChip user={{ status, invite }} />
          </Box>
          <Box className={classes.lastSeen}>
            Last seen: {activeAt ? <TimeAgo date={isCurrentUser(id) ? new Date() : activeAt} /> : <>Never</>}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export { UserPanel }
